import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-3 col-lg-2 mt-4 ms-2 mx-2" }
const _hoisted_2 = {
  class: "card mx-3",
  style: {"width":"100%"}
}
const _hoisted_3 = {
  class: "row",
  style: {"padding-top":"10px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_5 = { class: "col-md-12 col-lg-3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-12 col-lg-7" }
const _hoisted_8 = { style: {"padding-top":"15px"} }
const _hoisted_9 = { id: "fechaC" }
const _hoisted_10 = {
  class: "card-body",
  id: "card-body"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-11" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { id: "problemas" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " file_download ", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-lg-12\" style=\"font-align:center!important;\"><h6 class=\"card-title\" style=\"font-size:12px!important;text-align:center!important;\" id=\"correo2\"></h6></div></div><p class=\"card-text\" id=\"descriptionReportes\" data-description=\"prueba\"><span class=\"badge bg-secondary ml-0\"></span></p>", 2)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Atender", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " done ", -1)
const _hoisted_22 = {
  key: 0,
  class: "badge bg-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            style: {"width":"50px"},
            class: "imgStatus cardimg-top img-responsive hidden-xs hidden-sm",
            src: _ctx.imgStatus(_ctx.file.status),
            alt: "Card image cap"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h6", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.dateFormat(_ctx.file.loaded_at)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h6", _hoisted_13, [
              _createElementVNode("b", null, _toDisplayString(_ctx.file.enterprise), 1)
            ]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.file.docs.length) + " Documentos ", 1)
          ]),
          _createElementVNode("div", {
            class: "col-lg-11",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download_file(_ctx.file._id)))
          }, _hoisted_16)
        ]),
        _hoisted_17,
        (_ctx.file.status==='unattended')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "verCompleto",
              class: "btn btn-sm btn-warning btn-block verCompleto",
              "data-bs-container": "body",
              "data-bs-placement": "top",
              "data-trigger": "hover",
              "data-bs-content": "Click para atender",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toAsign(_ctx.file._id)))
            }, _hoisted_20))
          : _createCommentVNode("", true),
        (_ctx.file.status=='asigned')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              id: "verCompleto",
              class: "btn btn-success btn-block verCompleto",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toClose(_ctx.file._id)))
            }, [
              _hoisted_21,
              (_ctx.file.status=='close')
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.file.status), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}